export enum KYCRequiredDataTestIDs {
    BUTTON = 'kyc_button'
}